import { Amplify, Auth } from 'aws-amplify';
import awsExports from '../aws-exports';
import { cache, clearCache } from '../components/common';
import { bpApi } from './axios';
import { getAuthorization } from './utils';

Amplify.configure(awsExports);

const redirectionUrl = {
  success: '/v2',
  failure: '/login',
};

export const whoami = async () => {
  const authorization = getAuthorization();
  const { data } = await bpApi.get('/whoami', { headers: { authorization } });
  return data;
};

export const login = async ({ email, password }) => {
  try {
    await Auth.signIn(email, password);
    const currentSession = await Auth.currentSession();

    cache.token(currentSession.getIdToken().getJwtToken());

    const {
      user: { id },
    } = (await whoami()) || {};

    cache.whoamiId(id);

    return redirectionUrl.success;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const logout = () => {
  try {
    Auth.signOut();
    clearCache();
  } catch (error) {
    throw new Error(error.message);
  }
};
